import _ from 'lodash';
import PropTypes from 'prop-types';
import { Table as ReactTable } from 'reactstrap';
import Checkbox from '../checkbox/checkbox';

const Table = ({
  headers,
  children,
  className,
  responsive,
  bordered,
  nestedHeaders,
  columnWidths,
  isCheckboxRequired,
  onCheckChanged,
  checked,
  checkBoxDisabled,
  id,
  onScroll,
}) => {
  const buildColGroup = () => {
    if (!columnWidths?.length) return null;

    return (
      <colgroup>
        {columnWidths.map((width, index) => (
          <col key={index} style={{ width }} />
        ))}
      </colgroup>
    );
  };

  const buildTableHeader = () => {
    if (nestedHeaders) {
      const tablehead = Object.keys(headers);
      const tableRows = _.map(tablehead, (tableHeaderTitle) => {
        const subHeaders = headers[tableHeaderTitle];
        if (!subHeaders) {
          return (
            <th key={tableHeaderTitle} rowSpan={2} className="table-header-title">
              {tableHeaderTitle}
            </th>
          );
        }

        return (
          <th key={tableHeaderTitle} colSpan={subHeaders.length} className="pay-off-header">
            <span>{tableHeaderTitle}</span>
          </th>
        );
      });
      const nestedTableRows = _.flatMap(tablehead, (tableHeaderTitle) => {
        const subHeaders = headers[tableHeaderTitle];
        if (!subHeaders) return [];

        const nestedHeaderWidth = columnWidths?.length ? undefined : `${100 / subHeaders.length}%`;
        return subHeaders.map((subItem, subIndex) => (
          <th
            key={`${tableHeaderTitle}-${subItem}-${subIndex}`}
            width={nestedHeaderWidth}
            className="center-align"
          >
            {subItem}
          </th>
        ));
      });

      return (
        <thead className="report-thead">
          <tr>{tableRows}</tr>
          <tr className="table-header-title">{nestedTableRows}</tr>
        </thead>
      );
    }
    const tableRows = _.map(headers, (tableHeaderTitle, index) => {
      return (
        <th key={index} className="table-header-title">
          {tableHeaderTitle}
        </th>
      );
    });

    return (
      <thead className="report-thead">
        <tr>
          {isCheckboxRequired && (
            <th className="table-header-title checkbox-table checkbox-th">
              <Checkbox
                name="global checkbox"
                disabled={checkBoxDisabled}
                simple
                onChange={onCheckChanged}
                checked={checked}
              />
            </th>
          )}
          {tableRows}
        </tr>
      </thead>
    );
  };

  return (
    <ReactTable
      responsive={responsive}
      bordered={bordered}
      className={className}
      id={id}
      onScroll={onScroll}
    >
      {buildColGroup()}
      {buildTableHeader()}
      {children}
    </ReactTable>
  );
};

Table.defaultProps = {
  headers: [],
  nestedHeaders: false,
  columnWidths: null,
  children: null,
  className: '',
  responsive: false,
  bordered: false,
  isCheckboxRequired: false,
  onCheckChanged: null,
  checked: false,
  checkBoxDisabled: false,
  id: '',
  onScroll: () => {},
};

Table.propTypes = {
  headers: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
  nestedHeaders: PropTypes.bool,
  columnWidths: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  className: PropTypes.string,
  responsive: PropTypes.bool,
  bordered: PropTypes.bool,
  isCheckboxRequired: PropTypes.bool,
  onCheckChanged: PropTypes.func,
  checked: PropTypes.bool,
  checkBoxDisabled: PropTypes.bool,
  id: PropTypes.string,
  onScroll: PropTypes.func,
};

export default Table;
